import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getBoxes } from 'services/funds'
import posthog from 'posthog-js'

export default function useGetFunds() {
    const [moneyPools, setMoneyPools] = useState<Array<MoneyPool> | undefined>()
    const [cashBoxes, setCashBoxes] = useState<Array<ICashBoxes> | undefined>()
    const { data, isLoading, isError, refetch } = useQuery(
        ['get-boxes'],
        getBoxes,
        // Shared with the home page and AccessPay. Without a stale time the
        // global refetchOnWindowFocus refired this on every tab focus.
        { staleTime: 60_000 }
    )
    useEffect(() => {
        if (data) {
            posthog.capture('funds_list_viewed', {
                moneypool_count: (data as any)?.moneypools?.length,
                cashbox_count: (data as any)?.cashboxes?.length,
            })
            setMoneyPools(data?.moneypools)
            setCashBoxes(data?.cashboxes)
        }
    }, [data])
    return { moneyPools, cashBoxes, isLoading, isError, refetch }
}
